module.exports = __webpack_public_path__ + "ClientApp/content/VetResourceCenter/euthanasia-best-practices.jpg";